import { bool, func, node, number } from 'prop-types';
import React from 'react';

import Titled from '../layout/Titled';
import QuoteList from './List';

const ListQuotes = ({
  opportunityId,
  actions,
  primaryQuoteId,
  showPagination,
  onUpdatePrimaryQuote,
  isEditing,
}) => (
  <Titled title="Quotes" size="sm" actions={actions}>
    <QuoteList
      opportunityId={opportunityId}
      primaryQuoteId={primaryQuoteId}
      showPagination={showPagination}
      onUpdatePrimaryQuote={onUpdatePrimaryQuote}
      isDisabled={!isEditing}
    />
  </Titled>
);

ListQuotes.propTypes = {
  actions: node,
  opportunityId: number.isRequired,
  primaryQuoteId: number,
  showPagination: bool,
  onUpdatePrimaryQuote: func,
  isEditing: bool,
};

ListQuotes.defaultProps = {
  primaryQuoteId: undefined,
  actions: undefined,
  showPagination: true,
  onUpdatePrimaryQuote() {
    window.location.reload();
  },
  isEditing: true,
};

export default ListQuotes;
